import { render, staticRenderFns } from "./FormDepartmentOwnership.vue?vue&type=template&id=4e175058&"
import script from "./FormDepartmentOwnership.vue?vue&type=script&lang=js&"
export * from "./FormDepartmentOwnership.vue?vue&type=script&lang=js&"
import style0 from "./FormDepartmentOwnership.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports